const helper = {
    // -------------------------------------------
    // TOP-LEVEL AGGREGATES
    // -------------------------------------------
    "00000000": { "name": "Total Nonfarm", "tier": 1, "parent": null },
    "05000000": { "name": "Total Private", "tier": 2, "parent": "00000000" },
    "06000000": { "name": "Goods Producing", "tier": 3, "parent": "05000000" },
    "07000000": { "name": "Service Providing", "tier": 3, "parent": "05000000" },
    "90000000": { "name": "Government", "tier": 2, "parent": "00000000" },
  
    // -------------------------------------------
    // EXISTING ENTRIES YOU PROVIDED
    // -------------------------------------------
    "10000000": { "name": "Mining and Logging", "tier": 4, "parent": "06000000" },
    "10113300": { "name": "Logging", "tier": 5, "parent": "10000000" },
  
    "20000000": { "name": "Construction", "tier": 4, "parent": "06000000" },
    "20236000": { "name": "Construction of Buildings", "tier": 5, "parent": "20000000" },
    "ResConst":  { "name": "Residential Building Construction",   "tier": 6, "parent": "20236000" },
    "NoResCon":  { "name": "Nonresidential Building Construction", "tier": 6, "parent": "20236000" },
    "20237000": { "name": "Heavy and Civil Engineering Construction", "tier": 5, "parent": "20000000" },
    "20238000": { "name": "Specialty Trade Contractors",            "tier": 5, "parent": "20000000" },
  
    "30000000": { "name": "Manufacturing", "tier": 4, "parent": "06000000" },
    "31000000": { "name": "Durable Goods", "tier": 5, "parent": "30000000" },
    "31332000": { "name": "Fabricated Metal Product Manufacturing",     "tier": 6, "parent": "31000000" },
    "31334000": { "name": "Computer and Electronic Product Manufacturing",  "tier": 6, "parent": "31000000" },
    "31334500": { "name": "Navigational, Measuring, Electromedical and Control", "tier": 7, "parent": "31334000" },
    "31336000": { "name": "Transportation Equipment Manufacturing", "tier": 6, "parent": "31000000" },
    "31336400": { "name": "Aerospace Product and Parts Manufacturing", "tier": 7, "parent": "31336000" },
    "32000000": { "name": "Nondurable Goods", "tier": 5, "parent": "30000000" },
    "32311000": { "name": "Food Manufacturing", "tier": 6, "parent": "32000000" },
  
    "40000000": { "name": "Trade, Transportation, and Utilities", "tier": 4, "parent": "07000000" },
    "41000000": { "name": "Wholesale Trade", "tier": 5, "parent": "40000000" },
    "42000000": { "name": "Retail Trade",    "tier": 5, "parent": "40000000" },
    "42441000": { "name": "Motor Vehicle and Parts Dealers", "tier": 6, "parent": "42000000" },
  
    "50000000": { "name": "Information", "tier": 4, "parent": "07000000" },
    "50511200": { "name": "Software Publishers", "tier": 6, "parent": "50000000" },
  
    "55000000": { "name": "Financial Activities", "tier": 4, "parent": "07000000" },
    "55520000": { "name": "Finance and Insurance",            "tier": 5, "parent": "55000000" },
    "55522000": { "name": "Credit Intermediation and Related Activities",    "tier": 6, "parent": "55520000" },
    "55524000": { "name": "Insurance Carriers and Related Activities",       "tier": 6, "parent": "55520000" },
  
    "60000000": { "name": "Professional and Business Services", "tier": 4, "parent": "07000000" },
    "60540000": { "name": "Professional, Scientific and Technical Services", "tier": 5, "parent": "60000000" },
    "60541500": { "name": "Computer Systems Design and Related Services",    "tier": 6, "parent": "60540000" },
  
    "65000000": { "name": "Educational and Health Services", "tier": 4, "parent": "07000000" },
    "65621000": { "name": "Ambulatory Health Care Services",  "tier": 6, "parent": "65000000" },
  
    "70000000": { "name": "Leisure and Hospitality", "tier": 4, "parent": "07000000" },
    "70722000": { "name": "Food Services and Drinking Places", "tier": 6, "parent": "70000000" },
  
    "90910000": { "name": "Federal Government",               "tier": 5, "parent": "90000000" },
    "90921611": { "name": "State Government Educational Services", "tier": 6, "parent": "90000000" },
    "90931611": { "name": "Local Government Educational Services", "tier": 6, "parent": "90000000" },
  
    // -------------------------------------------
    // NATURAL RESOURCES AND MINING (BLS aggregator: NAICS 11 & 21)
    // -------------------------------------------
    "06500000": {
      "name": "Natural Resources and Mining",
      "tier": 4,
      "parent": "06000000" // Goods Producing
    },
  
    // -------------------------------------------
    // REAL ESTATE AND RENTAL AND LEASING (NAICS 53)
    // -------------------------------------------
    "55530000": {
      "name": "Real Estate and Rental and Leasing",
      "tier": 5,
      "parent": "55000000" // Financial Activities
    },
  
    // -------------------------------------------
    // LEGAL SERVICES (NAICS 5411)
    // -------------------------------------------
    "60541100": {
      "name": "Legal Services",
      "tier": 6,
      "parent": "60540000" // Prof, Scientific, Technical
    },
  
    // -------------------------------------------
    // ACCOUNTING, TAX PREP, BOOKKEEPING, PAYROLL (NAICS 5412)
    // -------------------------------------------
    "60541200": {
      "name": "Accounting, Tax Preparation, Bookkeeping, and Payroll",
      "tier": 6,
      "parent": "60540000"
    },
  
    // -------------------------------------------
    // ARCHITECTURAL, ENGINEERING, AND RELATED (NAICS 5413)
    // -------------------------------------------
    "60541300": {
      "name": "Architectural, Engineering, and Related Services",
      "tier": 6,
      "parent": "60540000"
    },
  
    // -------------------------------------------
    // MANAGEMENT OF COMPANIES AND ENTERPRISES (NAICS 55)
    // -------------------------------------------
    "60600000": {
      "name": "Management of Companies and Enterprises",
      "tier": 5,
      "parent": "60000000" // Prof. and Business Svcs
    },
  
    // -------------------------------------------
    // ADMINISTRATIVE, SUPPORT, WASTE MGMT, REMED. (NAICS 56)
    // -------------------------------------------
    "60700000": {
      "name": "Administrative and Support and Waste Management and Remediation Services",
      "tier": 5,
      "parent": "60000000"
    },
  
    // -------------------------------------------
    // ARTS, ENTERTAINMENT, AND RECREATION (NAICS 71)
    // -------------------------------------------
    "70710000": {
      "name": "Arts, Entertainment, and Recreation",
      "tier": 5,
      "parent": "70000000"
    },
  
    // -------------------------------------------
    // ACCOMMODATION (NAICS 721)
    // -------------------------------------------
    "70721000": {
      "name": "Accommodation",
      "tier": 6,
      "parent": "70000000"
    },
  
    // -------------------------------------------
    // OTHER SERVICES -- code 80000000 introduced in Excel
    // -------------------------------------------
    // (You had references to it already via 80813000's parent)
    "80000000": {
      "name": "Other Services",
      "tier": 4,
      "parent": "07000000" // Service Providing
    },
  
    // Example sub-sectors of Other Services
    // from your Excel
    "80813000": {
      // Already in your snippet with this name
      "name": "Religious, Grantmaking, Civic, Professional, and Similar Organizations",
      "tier": 5,
      "parent": "80000000"
    },
  
    // -------------------------------------------
    // STATE & LOCAL GOVERNMENT
    // -------------------------------------------
    "90920000": {
      "name": "State Government",
      "tier": 5,
      "parent": "90000000"
    },
    "90930000": {
      "name": "Local Government",
      "tier": 5,
      "parent": "90000000"
    },
    "90940000": {
      "name": "Workers in Labor/Management Disputes",
      "tier": 5,
      "parent": "90000000"
    },
  
    // -------------------------------------------
    // BELOW THIS LINE: FILLING IN MISSING CODES FROM EXCEL
    // -------------------------------------------
  
    // -------------------------------------------
    // OTHER SERVICES sub-industries
    // -------------------------------------------
    "80811000": {
      "name": "Repair and Maintenance",
      "tier": 5,
      "parent": "80000000"
    },
    "80812000": {
      "name": "Personal and Laundry Services",
      "tier": 5,
      "parent": "80000000"
    },
    // ("80813000" was already added above)
  
    // -------------------------------------------
    // MANUFACTURING (Finer detail for Durable & Nondurable)
    // -------------------------------------------
    "31321000": {
      "name": "Wood Product Manufacturing",
      "tier": 6,
      "parent": "31000000"
    },
    "31321100": {
      "name": "Sawmills and Wood Preservation",
      "tier": 7,
      "parent": "31321000"
    },
    "31327000": {
      "name": "Nonmetallic Mineral Product Manufacturing",
      "tier": 6,
      "parent": "31000000"
    },
    "31333000": {
      "name": "Machinery Manufacturing",
      "tier": 6,
      "parent": "31000000"
    },
  
    // Nondurable expansions
    "32311400": {
      "name": "Fruit and Vegetable Preserving and Specialty",
      "tier": 7,
      "parent": "32311000"
    },
    "32311111": {
      "name": "Other Food Manufacturing",
      "tier": 7,
      "parent": "32311000"
    },
    "32322000": {
      "name": "Paper Manufacturing",
      "tier": 6,
      "parent": "32000000"
    },
    "32323000": {
      "name": "Printing and Related Support Activities",
      "tier": 6,
      "parent": "32000000"
    },
  
    // -------------------------------------------
    // WHOLESALE TRADE expansions
    // -------------------------------------------
    "41423000": {
      "name": "Merchant Wholesalers, Durable Goods",
      "tier": 6,
      "parent": "41000000"
    },
    "41424000": {
      "name": "Merchant Wholesalers, Nondurable Goods",
      "tier": 6,
      "parent": "41000000"
    },
    "41425000": {
      "name": "Electronic Markets and Agents and Brokers",
      "tier": 6,
      "parent": "41000000"
    },
  
    // -------------------------------------------
    // RETAIL TRADE expansions
    // -------------------------------------------
    "42442000": {
      "name": "Furniture and Home Furnishing Stores",
      "tier": 6,
      "parent": "42000000"
    },
    "42444000": {
      "name": "Building Material and Garden Supply Stores",
      "tier": 6,
      "parent": "42000000"
    },
    "42445000": {
      "name": "Food and Beverage Stores",
      "tier": 6,
      "parent": "42000000"
    },
    "42446000": {
      "name": "Health and Personal Care Stores",
      "tier": 6,
      "parent": "42000000"
    },
    "42448000": {
      "name": "Clothing and Clothing Accessories Stores",
      "tier": 6,
      "parent": "42000000"
    },
    "42452000": {
      "name": "General Merchandise Stores",
      "tier": 6,
      "parent": "42000000"
    },
    "42111111": {
      "name": "Other Retail Trade",
      "tier": 6,
      "parent": "42000000"
    },
  
    // -------------------------------------------
    // TRANSPORTATION, WAREHOUSING & UTILITIES expansions
    // -------------------------------------------
    // (We add "43000000" as a child of 40000000, then its subcodes.)
    "43000000": {
      "name": "Transportation, Warehousing and Utilities",
      "tier": 5,
      "parent": "40000000"
    },
    "43220000": {
      "name": "Utilities",
      "tier": 6,
      "parent": "43000000"
    },
    "43400089": {
      "name": "Transportation and Warehousing",
      "tier": 6,
      "parent": "43000000"
    },
    "43481000": {
      "name": "Air Transportation",
      "tier": 7,
      "parent": "43400089"
    },
    "43484000": {
      "name": "Truck Transportation",
      "tier": 7,
      "parent": "43400089"
    },
    "43488000": {
      "name": "Support Activities for Transportation",
      "tier": 7,
      "parent": "43400089"
    },
    "43493000": {
      "name": "Warehousing and Storage",
      "tier": 7,
      "parent": "43400089"
    },
  
    // -------------------------------------------
    // INFORMATION expansions
    // (Publishing Industries except Internet)
    // -------------------------------------------
    "50511000": {
      "name": "Publishing Industries except Internet",
      "tier": 5,
      "parent": "50000000"
      // NOTE: Excel shows Software Publishers under this,
      // but your existing snippet had parent=50000000 directly for 50511200
    },
  
    // -------------------------------------------
    // ADMIN & SUPPORT, WASTE MGMT (subcodes under your "60700000")
    // -------------------------------------------
    "60561000": {
      "name": "Administrative and Support Services",
      "tier": 6,
      "parent": "60700000"
    },
    "60561111": {
      "name": "Other Administrative Services",
      "tier": 7,
      "parent": "60561000"
    },
    "60561300": {
      "name": "Employment Services",
      "tier": 7,
      "parent": "60561000"
    },
    "60562000": {
      "name": "Waste Management and Remediation Services",
      "tier": 6,
      "parent": "60700000"
    },
  
    // -------------------------------------------
    // EDUCATIONAL & HEALTH SERVICES expansions
    // -------------------------------------------
    "65610000": {
      "name": "Educational Services",
      "tier": 5,
      "parent": "65000000"
    },
    // (You already have 65621000 under 65000000, so we keep that structure.)
    "65622000": {
      "name": "Hospitals",
      "tier": 6,
      "parent": "65000000"
    },
    "65623000": {
      "name": "Nursing and Residential Care Facilities",
      "tier": 6,
      "parent": "65000000"
    },
    "65624000": {
      "name": "Social Assistance",
      "tier": 6,
      "parent": "65000000"
    },
  
    // -------------------------------------------
    // MISSING LOCAL GOV’T SUBCODE (from Excel)
    // -------------------------------------------
    "90931111": {
      "name": "Other Local Government",
      "tier": 6,
      "parent": "90930000"
    }
  };
  
  export default helper;